import { Chip } from '@mui/material'
import { getSeverityColor, getSeverityTextColor } from '../charts/_helpers'

const AlertChip = ({ severity, count }: { severity: number; count: number }) => {
  const color = getSeverityColor(severity, 0.8)
  const textColor = getSeverityTextColor(severity)

  return count > 0 ? (
    <Chip
      label={count}
      size="small"
      sx={{
        bgcolor: color,
        color: textColor,
      }}
    />
  ) : null
}
export default AlertChip
